import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { auth, db } from '../../firebase/firebase';
import { useNavigate } from 'react-router-dom';
import Usuarios from '../AdminComponets/Usuarios';
import Administradores from '../AdminComponets/Administradores';
import { collection, getDocs } from 'firebase/firestore';
import Dashboard from '../AdminComponets/Dashboard';


const AdminScreen = (props) => {

  const navigate = useNavigate();
  const [usuarioActivo, setUsuarioActivo] = useState(null);
  const [value, setValue] = React.useState('1');

  const [esAdmin, setEsAdmin] = useState(false);
  const [usuarios, setUsuarios] = useState([])

  useEffect(() => {
    obtenerUsuarios();
  }, [])

  const obtenerUsuarios = async() =>{
    const user = auth.currentUser;
    let admin = false;

    const querySnapshot = await getDocs(collection(db, 'usuarios'))
    const arrayData = querySnapshot.docs.map( doc =>(
      {id: doc.id, ...doc.data()}
    ))

    setUsuarios(arrayData);

    arrayData.forEach((usuario)=>{
      if(usuario.uid === user.uid){
        if(usuario.rol === 'admin' || usuario.rol === 'super'){
          setEsAdmin(true);
          admin = true;
        }
      }
    })
    if(admin){
      setUsuarioActivo(user); 
    }else{
      navigate('/');
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  return (
    <>
        {
          usuarioActivo && (
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={value} >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }} >
                  <TabList onChange={handleChange} aria-label="lab API tabs example" centered>
                    <Tab label="Resumen" value="1" />
                    <Tab label="Usuarios" value="2" />
                    <Tab label="Administradores" value="3" />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <Dashboard/>
                </TabPanel>
                <TabPanel value="2">
                  <Usuarios/>
                </TabPanel>
                <TabPanel value="3">
                  <Administradores/>
                </TabPanel>
              </TabContext>
            </Box>
          )
        }
    </>
  )
}

export default AdminScreen